(function ($) {
    "use strict";
	
	var $window = $(window); 
	var $body = $('body'); 

	/* Preloader Effect */
	$window.on('load', function(){
		$(".preloader").fadeOut(600);
	});

	/* Sticky Header */	
	if($('.active-sticky-header').length){
		$window.on('resize', function(){
			setHeaderHeight();
		});

		function setHeaderHeight(){
	 		$("header.active-sticky-header").css("height", $('header.active-sticky-header .header-sticky').outerHeight());
		}	
	
		$window.on("scroll", function() {
			var fromTop = $(window).scrollTop();
			setHeaderHeight();
			var headerHeight = $('header.active-sticky-header .header-sticky').outerHeight()
			$("header.active-sticky-header .header-sticky").toggleClass("hide", (fromTop > headerHeight + 100));
			$("header.active-sticky-header .header-sticky").toggleClass("active", (fromTop > 600));
		});
	}	
	
	/* Slick Menu JS */
	$('#menu').slicknav({
		label : '',
		prependTo : '.responsive-menu'
	});

	if($("a[href='#top']").length){
		$(document).on("click", "a[href='#top']", function() {
			$("html, body").animate({ scrollTop: 0 }, "slow");
			return false;
		});
	}

	/* Hero Banner Slider JS */
	if ($('.hero-slider').length) {
		var $heroSlider = $('.hero-slider');
		var heroSlideCount = $heroSlider.find('.swiper-slide').length;
		var heroAutoplay = $heroSlider.data('autoplay') === true || $heroSlider.data('autoplay') === 'true';
		var heroSpeed = parseInt($heroSlider.data('speed'), 10) || 6000;

		var heroSwiper = new Swiper('.hero-slider', {
			slidesPerView: 1,
			autoHeight: true,
			effect: 'fade',
			fadeEffect: { crossFade: true },
			speed: 900,
			rewind: heroSlideCount > 1,
			allowTouchMove: heroSlideCount > 1,
			autoplay: (heroAutoplay && heroSlideCount > 1) ? {
				delay: heroSpeed,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			} : false,
			pagination: {
				el: '.hero-slider-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.hero-slider-button-next',
				prevEl: '.hero-slider-button-prev',
			},
		});

		$heroSlider.find('img').each(function () {
			if (!this.complete) {
				$(this).one('load', function () { heroSwiper.updateAutoHeight(0); });
			}
		});
		$window.on('load resize', function () { heroSwiper.updateAutoHeight(0); });
	}

	/* Top Selling Category Auto-Scroll Slider JS */
	if ($('.top-selling-slider').length) {
		new Swiper('.top-selling-slider .swiper', {
			slidesPerView: 3,
			spaceBetween: 20,
			loop: true,
			speed: 4000,
			allowTouchMove: true,
			autoplay: {
				delay: 1,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			breakpoints: {
				400: {
					slidesPerView: 3,
				},
				576: {
					slidesPerView: 4,
				},
				768: {
					slidesPerView: 5,
				},
				992: {
					slidesPerView: 6,
				}
			}
		});
	}

	/* Product Slider JS */
	if ($('.product-slider').length) {
		const testimonial_slider = new Swiper('.product-slider .swiper', {
			slidesPerView : 1,
			speed: 1500,
			spaceBetween: 10,
			loop: true,
			autoplay: {
				delay: 5000,
			},
			navigation: {
				nextEl: '.product-slider-button-next',
				prevEl: '.product-slider-button-prev',
			},
			breakpoints: {
				768:{
					slidesPerView: 2,
				},
				991:{
					slidesPerView: 3,
				},
				1366:{
					slidesPerView: 4,
				}
			}
		});
	}

	/* Product Single Image Slider JS */
	// THUMBNAILS (LEFT)
	var swiperThumbs = new Swiper(".product-single-image-slider", {
		spaceBetween: 10,
		slidesPerView: 3,
		loop: true,
		speed: 1000,
		watchSlidesProgress: true,
		slideToClickedSlide: true,
		allowTouchMove: true,
		breakpoints:{
			767:{
				spaceBetween: 0,
			}
		}
	});

	// MAIN IMAGE (RIGHT)
	var swiperMain = new Swiper(".product-single-image-item", {
		spaceBetween: 0,
		slidesPerView: 1,
		loop: true,
		speed: 1000,
		thumbs: {
			swiper: swiperThumbs,
		},
	});

	/* Product Image Hover Zoom JS (desktop only) */
	if ($('.product-zoom').length) {
		var zoomRatio = 2.2;

		$(document).on('mouseenter', '.product-zoom figure[data-zoom-image]', function () {
			if ($window.width() <= 991) return;

			var $figure = $(this);
			var $img = $figure.find('img');
			var $container = $figure.closest('.product-zoom');
			var $lens = $container.find('.product-zoom-lens');
			var $pane = $container.find('.product-zoom-pane');
			var zoomSrc = $figure.attr('data-zoom-image');

			if (!zoomSrc || !$img.length) return;

			$pane.css('background-image', 'url("' + zoomSrc + '")');
			$container.addClass('is-zooming');

			var lensWidth = $img.outerWidth() / zoomRatio;
			var scale = $pane.outerWidth() / lensWidth;
			var lensHeight = $pane.outerHeight() / scale;
			$container.data('zoomScale', scale);
			$lens.css({ width: lensWidth + 'px', height: lensHeight + 'px' });
		});

		$(document).on('mousemove', '.product-zoom figure[data-zoom-image]', function (event) {
			if ($window.width() <= 991) return;

			var $figure = $(this);
			var $img = $figure.find('img');
			var $container = $figure.closest('.product-zoom');
			var $lens = $container.find('.product-zoom-lens');
			var $pane = $container.find('.product-zoom-pane');

			if (!$img.length) return;

			var offset = $img.offset();
			var imgWidth = $img.outerWidth();
			var imgHeight = $img.outerHeight();
			var lensWidth = $lens.outerWidth();
			var lensHeight = $lens.outerHeight();

			var x = Math.max(0, Math.min(event.pageX - offset.left, imgWidth));
			var y = Math.max(0, Math.min(event.pageY - offset.top, imgHeight));

			var lensX = Math.max(0, Math.min(x - (lensWidth / 2), imgWidth - lensWidth));
			var lensY = Math.max(0, Math.min(y - (lensHeight / 2), imgHeight - lensHeight));

			var rangeX = imgWidth - lensWidth;
			var rangeY = imgHeight - lensHeight;
			var bgX = rangeX > 0 ? (lensX / rangeX) * 100 : 0;
			var bgY = rangeY > 0 ? (lensY / rangeY) * 100 : 0;

			$lens.css({ left: lensX + 'px', top: lensY + 'px' });
			var scale = $container.data('zoomScale') || zoomRatio;
			$pane.css({
				'background-size': (imgWidth * scale) + 'px ' + (imgHeight * scale) + 'px',
				'background-position': bgX + '% ' + bgY + '%',
			});
		});

		$(document).on('mouseleave', '.product-zoom figure[data-zoom-image]', function () {
			$(this).closest('.product-zoom').removeClass('is-zooming');
		});
	}


	/* Testimonial Slider JS */
	if ($('.testimonial-slider').length) {
		const testimonial_slider = new Swiper('.testimonial-slider .swiper', {
			slidesPerView : 1,
			speed: 2500,
			spaceBetween: 60,
			loop: true,
			autoplay: {
				delay: 5000,
			},
			navigation: {
				nextEl: '.testimonial-button-next',
				prevEl: '.testimonial-button-prev',
			},
			breakpoints: {
				768:{
					slidesPerView: 1,
				},
			}
		});
	}

	/* Skill Bar */
	if ($('.skills-progress-bar').length) {
		$('.skills-progress-bar').waypoint(function() {
			$('.skillbar').each(function() {
				$(this).find('.count-bar').animate({
				width:$(this).attr('data-percent')
				},2000);
			});
		},{
			offset: '70%'
		});
	}

	/* Youtube Background Video JS */
	if ($('#myVideo').length) {
		var myPlayer = $("#myVideo").YTPlayer();
	}

	/* Init Counter */
	if ($('.counter').length) {
		$('.counter').counterUp({ delay: 6, time: 3000 });
	}

	/* Image Reveal Animation */
	if ($('.reveal').length) {
        gsap.registerPlugin(ScrollTrigger);
        let revealContainers = document.querySelectorAll(".reveal");
        revealContainers.forEach((container) => {
            let image = container.querySelector("img");
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    toggleActions: "play none none none"
                }
            });
            tl.set(container, {
                autoAlpha: 1
            });
            tl.from(container, 1, {
                xPercent: -100,
                ease: Power2.out
            });
            tl.from(image, 1, {
                xPercent: 100,
                scale: 1,
                delay: -1,
                ease: Power2.out
            });
        });
    }

	/* Text Effect Animation */
	function initHeadingAnimation() {
		
		if($('.text-effect').length) {
			var textheading = $(".text-effect");

			if(textheading.length === 0) return; gsap.registerPlugin(SplitText); textheading.each(function(index, el) {
				
				el.split = new SplitText(el, { 
					type: "lines,words,chars",
					linesClass: "split-line"
				});
				
				if( $(el).hasClass('text-effect') ){
					gsap.set(el.split.chars, {
						opacity: .3,
						x: "-7",
					});
				}
				el.anim = gsap.to(el.split.chars, {
					scrollTrigger: {
						trigger: el,
						start: "top 92%",
						end: "top 60%",
						markers: false,
						scrub: 1,
					},

					x: "0",
					y: "0",
					opacity: 1,
					duration: .7,
					stagger: 0.2,
				});
			});
		}
		
		if ($('.text-anime-style-1').length) {
			let staggerAmount 	= 0.05,
				translateXValue = 0,
				delayValue 		= 0.5,
			   animatedTextElements = document.querySelectorAll('.text-anime-style-1');
			
			animatedTextElements.forEach((element) => {
				let animationSplitText = new SplitText(element, { type: "chars, words" });
					gsap.from(animationSplitText.words, {
					duration: 1,
					delay: delayValue,
					x: 20,
					autoAlpha: 0,
					stagger: staggerAmount,
					scrollTrigger: { trigger: element, start: "top 85%" },
					});
			});		
		}
		
		if ($('.text-anime-style-2').length) {				
			let	 staggerAmount 		= 0.03,
				 translateXValue	= 20,
				 delayValue 		= 0.1,
				 easeType 			= "power2.out",
				 animatedTextElements = document.querySelectorAll('.text-anime-style-2');
			
			animatedTextElements.forEach((element) => {
				let animationSplitText = new SplitText(element, { type: "chars, words" });
					gsap.from(animationSplitText.chars, {
						duration: 1,
						delay: delayValue,
						x: translateXValue,
						autoAlpha: 0,
						stagger: staggerAmount,
						ease: easeType,
						scrollTrigger: { trigger: element, start: "top 85%"},
					});
			});		
		}
		
		if ($('.text-anime-style-3').length && window.innerWidth > 991) {
			let	animatedTextElements = document.querySelectorAll('.text-anime-style-3');

			 animatedTextElements.forEach((element) => {
				//Reset if needed
				if (element.animation) {
					element.animation.progress(1).kill();
					element.split.revert();
				}

				element.split = new SplitText(element, {
					type: "lines,words,chars",
					linesClass: "split-line",
				});
				gsap.set(element, { perspective: 400 });

				gsap.set(element.split.chars, {
					opacity: 0,
					x: "50",
				});

				element.animation = gsap.to(element.split.chars, {
					scrollTrigger: { trigger: element,	start: "top 90%" },
					x: "0",
					y: "0",
					rotateX: "0",
					opacity: 1,
					duration: 1,
					ease: Back.easeOut,
					stagger: 0.02,
				});
			});		
		}
	}
	
	if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
            initHeadingAnimation();
        });
    } else {
        window.addEventListener("load", initHeadingAnimation);
    }

	/* Parallaxie js */
	var $parallaxie = $('.parallaxie');
	if($parallaxie.length && ($window.width() > 1024))
	{
		if ($window.width() > 768) {
			$parallaxie.parallaxie({
				speed: 0.55,
				offset: 0,
			});
		}
	}

	/* Zoom Gallery screenshot */
	$('.gallery-items').magnificPopup({
		delegate: 'a',
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		mainClass: 'mfp-with-zoom',
		image: {
			verticalFit: true,
		},
		gallery: {
			enabled: true
		},
		zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
			  return element.find('img');
			}
		}
	});

	/* Contact form validation */
	var $contactform = $("#contactForm");
	$contactform.validator({focus: false}).on("submit", function (event) {
		if (!event.isDefaultPrevented()) {
			event.preventDefault();
			submitForm();
		}
	});

	function submitForm(){
		/* Ajax call to submit form */
		$.ajax({
			type: "POST",
			url: "form-process.php",
			data: $contactform.serialize(),
			success : function(text){
				if (text === "success"){
					formSuccess();
				} else {
					submitMSG(false,text);
				}
			}
		});
	}

	function formSuccess(){
		$contactform[0].reset();
		submitMSG(true, "Message Sent Successfully!")
	}

	function submitMSG(valid, msg){
		if(valid){
			var msgClasses = "h4 text-success";
		} else {
			var msgClasses = "h4 text-danger";
		}
		$("#msgSubmit").removeClass().addClass(msgClasses).text(msg);
	}
	/* Contact form validation end */

	/* Animated Wow Js */	
	new WOW().init();

	/* Popup Video */
	if ($('.popup-video').length) {
		$('.popup-video').magnificPopup({
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: true
		});
	}
	
	/* product quantity Input Js */
	document.querySelectorAll(".qty-box").forEach(box => {
		const input = box.querySelector(".qty-input");

		box.querySelector(".plus").onclick = () =>
		input.value = String(+input.value + 1).padStart(2, "0");

		box.querySelector(".minus").onclick = () =>
		input.value = String(Math.max(1, +input.value - 1)).padStart(2, "0");
	});
	
})(jQuery);